import { defineComponent, createBlock, openBlock, mergeProps, unref, withCtx, renderSlot } from "vue";
import _sfc_main$1 from "../core/TabsContent.js";
import { reactiveOmit } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "TabsWrapperItem",
  props: {
    id: {},
    title: { type: [Object, String, Number, Boolean, null, Array, Function] },
    titleClass: {},
    disabled: { type: Boolean },
    class: {},
    forceMount: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  setup(__props) {
    const props = __props, tabsContentProps = reactiveOmit(props, ["id", "title", "titleClass", "disabled"]);
    return (_ctx, _cache) => (openBlock(), createBlock(_sfc_main$1, mergeProps(unref(tabsContentProps), {
      value: props.id
    }), {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 16, ["value"]));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=TabsWrapperItem.js.map
